/** @jsxImportSource @emotion/react */
import { TextNova } from "@/components/TextNova";
import { usePrismic } from "@/hooks/usePrismic";
import { IconApp } from "@/modules/IconApp";
import { footerStyles } from "./style";

export const Footer = () => {
  const t = usePrismic();
  return (
    <div css={footerStyles}>
      <div>
        <TextNova variant="label">{t.home.social}</TextNova>
        <IconApp name="facebook" color="blueGray200" />
        <IconApp name="twitter" color="blueGray200" />
        <IconApp name="youtube" color="blueGray200" />
        <IconApp name="instagram" color="blueGray200" />
        <IconApp name="linkedin" color="blueGray200" />
      </div>
      <div>
        <TextNova variant="copyright">{t.home.copyright}</TextNova>
      </div>
      <div>
        <IconApp name="iconNovaventa" width={80} height={25} color="blueGray200" />
        <IconApp name="iconNutresa" width={80} height={25} color="blueGray200" />
      </div>
    </div>
  );
};
